import {CONFIGURABLE_COLUMN_NAMES} from "../components/dashboard/columns";
import {APIClient} from "./APIClient";
import {API_URL} from "../settings/local_settings";

export class DashboardConfig {
    // filters

    resetFilters() {
        this.saveIssuesOnlyFilter(false);
        this.savePlatformFilter([]);
        this.saveLabelsFilter([]);
        this.saveTextFilter("");
    }

    saveTextFilter(value) {
        localStorage.setItem('textFilter', value);
    }

    saveIssuesOnlyFilter(value) {
        localStorage.setItem('issuesOnlyFilter', JSON.stringify(value));
    }

    saveLabelsFilter(labels) {
        localStorage.setItem('labelsFilter', JSON.stringify(labels));
    }

    savePlatformFilter(value) {
        const normalized = Array.isArray(value) ? value : (value ? [value] : []);
        localStorage.setItem('platformFilter', JSON.stringify(normalized));
    }

    saveColumnOrdering(value) {
        const columnOrderingJson = {'columnId': value.columnId(), 'orderingDirection': value.orderingDirection()};
        localStorage.setItem('columnOrdering', JSON.stringify(columnOrderingJson));
    }

    getPlatformFilter() {
        const platformFilter = localStorage.getItem('platformFilter');
        if (platformFilter === null || platformFilter === '') {
            return [];
        }
        try {
            const parsed = JSON.parse(platformFilter);
            if (Array.isArray(parsed)) return parsed;
            return parsed ? [parsed] : [];
        } catch (e) {
            return platformFilter ? [platformFilter] : [];
        }
    }

    saveHiddenColumns(hiddenColumns) {
        const normalized = Array.isArray(hiddenColumns) ? hiddenColumns : [];
        localStorage.setItem('hiddenDashboardColumns', JSON.stringify(normalized));
    }

    getHiddenColumns() {
        const raw = localStorage.getItem('hiddenDashboardColumns');
        if (raw === null || raw === '') return [];
        try {
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            return [];
        }
    }

    getTextFilter() {
        const textFilter = localStorage.getItem('textFilter');
        if (textFilter !== null) {
            return textFilter;
        } else {
            return ''
        }
    }

    getIssuesOnlyFilter() {
        const issuesOnlyFilter = localStorage.getItem('issuesOnlyFilter');
        if (issuesOnlyFilter !== null) {
            return JSON.parse(issuesOnlyFilter);
        } else {
            return false
        }
    }

    getLabelsFilter() {
        const labelsFilter = localStorage.getItem('labelsFilter');
        if (labelsFilter !== null) {
            return JSON.parse(labelsFilter)
        } else {
            return []
        }
    }

    getColumnOrdering() {
        return localStorage.getItem('columnOrdering');
    }

    saveColumnSet(setId, setName, columns) {
        // Si setId es null o undefined, se crea uno nuevo
        const columnSetData = setId 
            ? {id: setId, name: setName, columns: columns}
            : {name: setName, columns: columns};
        return this.handleColumnsSets(columnSetData)
    }

    deleteColumnSet(setId) {
        return new APIClient(API_URL + `dashboard/columns-sets/${setId}/`).call('DELETE')
            .then((responseData) => {
                if (responseData.status === 'ERROR') {
                    return Promise.reject({
                        status: 'ERROR',
                        errors: [{ message: responseData.error_message || 'Error al borrar el set de columnas' }]
                    });
                } else if (responseData.status === 'OK' || responseData.status === 'SUCCESS') {
                    return responseData.data || responseData.object;
                }
                return null;
            })
            .catch((error) => {
                return Promise.reject({
                    status: 'ERROR',
                    errors: [{ message: error.message || 'Error al borrar el set de columnas' }]
                });
            });
    }

    applyColumnSet(setId) {
        const setData = {set_id: setId};
        new APIClient(API_URL + 'dashboard/current-columns-set').call('POST', setData)
            .then((responseData) => {
                if (responseData.status === 'ERROR') {
                    alert(responseData['error_message']);
                } else if (responseData.status === 'OK') {
                }
            });
    }

    // active columns

    saveActiveColumns(activeColumns) {
        this.handleDefaultColumnsChange(JSON.stringify(activeColumns))
    }

    handleColumnsSets(newColumnsSets) {
        return new APIClient(API_URL + 'dashboard/columns-sets').call('POST', newColumnsSets)
            .then((responseData) => {
                if (responseData.status === 'ERROR') {
                    return Promise.reject({
                        status: 'ERROR',
                        errors: [{ message: responseData.error_message || 'Error al guardar el set de columnas' }]
                    });
                } else if (responseData.status === 'OK' || responseData.status === 'SUCCESS') {
                    // El backend devuelve el set guardado con su ID
                    return responseData.data || responseData.object || newColumnsSets;
                }
                return null;
            })
            .catch((error) => {
                return Promise.reject({
                    status: 'ERROR',
                    errors: [{ message: error.message || 'Error al guardar el set de columnas' }]
                });
            });
    }

    handleDefaultColumnsChange(newActiveColumns) {
        new APIClient(API_URL + 'dashboard/default-columns').call('POST', newActiveColumns)
            .then((responseData) => {
                if (responseData.status === 'ERROR') {
                    alert(responseData['error_message']);
                } else if (responseData.status === 'OK') {
                }
            });
    }

    retrieveColumnsSets(columnSetsCallback) {
        new APIClient(API_URL + 'dashboard/columns-sets').call('GET')
            .then((responseData) => {
                if (responseData.status === 'ERROR') {
                    alert(responseData['error_message']);
                } else if (responseData.status === 'OK') {
                    let formattedResponseData = {};
                    // El backend devuelve un array de objetos con id, name y columns
                    if (Array.isArray(responseData.data.column_sets)) {
                        responseData.data.column_sets.forEach((set) => {
                            formattedResponseData[set.id] = {
                                id: set.id,
                                name: set.name,
                                columns: set.columns
                            };
                        });
                    }
                    columnSetsCallback(formattedResponseData)
                }
            });
    }

    retrieveDefaultConfiguration(activeColumnsCallback) {
        new APIClient(API_URL + 'dashboard/default-columns').call('GET')
            .then((responseData) => {
                if (responseData.status === 'ERROR') {
                    alert(responseData['error_message']);
                } else if (responseData.status === 'OK') {
                    activeColumnsCallback(responseData.data)
                }
            });
    }

    static defaultActiveColumns() {
        return CONFIGURABLE_COLUMN_NAMES;
    }
}
